import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuthStore } from '@/stores/authStore';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

function OwnerNotSupported() {
  const { t } = useTranslation();
  const logout = useAuthStore((s) => s.logout);
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="max-w-md" title={t('web.owner_not_supported.title')}>
        <p className="mb-4 text-sm text-slate-600">{t('web.owner_not_supported.body')}</p>
        <Button variant="secondary" onClick={() => void logout()}>
          {t('web.nav.logout')}
        </Button>
      </Card>
    </div>
  );
}

export function ProtectedRoute() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const isHydrated = useAuthStore((s) => s.isHydrated);

  if (!isHydrated) return null;
  if (!token || !user) return <Navigate to="/login" replace />;
  // Веб — портал арендатора. «Чистого» владельца (владеет, но не арендатор)
  // отправляем в мобильное приложение; both-аккаунт проходит как арендатор.
  if (user.is_owner && !user.is_tenant) return <OwnerNotSupported />;

  return <Outlet />;
}
